import { showModal } from "../../../store/slices/modalSlice";
import { useTypedDispatch } from "../../../store/store";
import MODAL from "../../../utils/constants/modal";
import BookingDetails from "../../base/BookingDetails";
import PaymentProviderRenderer from "../../payments";
import Button from "../../shared/Button";

import styles from "./index.module.scss";

function Payment() {
  const dispatch = useTypedDispatch();

  const handleShowItineraryModal = () => {
    dispatch(showModal({ type: MODAL.MODAL_TYPES.ITINERARY }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.left}>
          <PaymentProviderRenderer />
        </div>

        <div className={styles.right}>
          <Button
            label="view itinerary"
            variant="secondary"
            icon="FiPlus"
            onClick={handleShowItineraryModal}
          />

          <BookingDetails />
        </div>
      </div>
    </div>
  );
}

export default Payment;
